<template>
  <v-simple-table
    class="expert-tool__table"
    fixed-header
  >
    <template v-slot:default>
      <tbody>
        <tr
          v-for="(rule, i) in prescriptionRules"
          :key="`${rule.key}-${i}`"
        >
          <td class="expert-tool__table-checkbox-cell">
            <v-checkbox
              v-model="selectedRules"
              :value="rule.key"
              color="success"
            ></v-checkbox>
          </td>
          <td class="expert-tool__table-item-name">{{ rule.name }}</td>
          <td
            v-for="(column, j) in columns"
            :key="`${column.name}-${i}-${j}`"
          >
            <div class="expert-tool__table-cell-content">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="expert-tool__table-cell-icon"
                    v-bind="attrs"
                    v-on="on"
                  >{{ column.icon }}</v-icon>
                </template>
                <span>
                  {{ $ucfirst($t(column.name === 'strengthTraining'
                    ? 'pa.strengthTraining'
                    : `expertTool.columnNames.${column.name}`
                  )) }}
                </span>
              </v-tooltip>
              <span
                :class="{ 'expert-tool__frequency-label': column.name === 'frequency' || !rule[`${column.name}Label`] || rule[`${column.name}Label`].length < 15 }"
              >{{ rule[`${column.name}Label`] || '' }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
/**
 * Component PrescriptionRulesTable.vue
 *
 * @module PrescriptionRulesTable
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/views/ExpertTool/SportsGoalBoxes/PrescriptionRulesTable.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export default {
  name: 'PrescriptionRulesTable',
  props: {
    ruleType: {
      type: String,
      required: true,
    },
  },
  computed: {
    prescriptionRules() {
      return this.$store.getters['expertTool/prescriptionRules']
        .filter((item) => item.type === this.ruleType);
    },
    columns() {
      return this.$store.getters['expertTool/columns'];
    },
    selectedRules: {
      get() {
        return this.$store.getters['expertTool/selectedRules'];
      },
      set(selected) {
        this.$store.dispatch('patientSummary/toggleUnsavedChanges', true);
        return this.$store.dispatch('expertTool/updateSelectedRules', selected);
      },
    },
  },
};
</script>
